var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHowToAnswer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 107 107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.044.177h49.219v37.955H.044z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M.044.009h49.219v37.954H.044z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M0 59.725h80.74V.19H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 53.5,
    cy: 53.5,
    r: 53.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F4F4F8",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.19 19.744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.523 37.875H19.636a5.396 5.396 0 01-5.395-5.396V5.857A5.396 5.396 0 0119.636.46h37.887a5.395 5.395 0 015.395 5.396v26.622a5.396 5.396 0 01-5.395 5.396",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.926 .013)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.71.718A5.131 5.131 0 00.585 5.843v26.623a5.13 5.13 0 005.125 5.125h37.887c2.826 0 5.125-2.3 5.125-5.125V5.843c0-2.826-2.3-5.125-5.125-5.125H5.71zm37.887 37.414H5.71a5.672 5.672 0 01-5.666-5.666V5.843A5.672 5.672 0 015.71.177h37.887a5.672 5.672 0 015.666 5.666v26.623a5.672 5.672 0 01-5.666 5.666z",
    fill: "#231F20",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M62.646 31.92V20.182H34.887a5.653 5.653 0 00-5.653 5.653v11.736h27.76a5.653 5.653 0 005.652-5.653",
    fill: "#DFDDE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.074 59.454H37.188a5.396 5.396 0 01-5.396-5.395V27.436a5.396 5.396 0 015.396-5.395h37.886a5.396 5.396 0 015.396 5.395V54.06a5.396 5.396 0 01-5.396 5.395",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.477 21.761)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.71.55A5.131 5.131 0 00.585 5.675v26.622c0 2.826 2.3 5.126 5.125 5.126h37.887c2.826 0 5.125-2.3 5.125-5.126V5.675A5.13 5.13 0 0043.597.55H5.71zm37.887 37.413H5.71a5.672 5.672 0 01-5.666-5.666V5.675A5.672 5.672 0 015.71.009h37.887a5.672 5.672 0 015.666 5.666v26.622a5.672 5.672 0 01-5.666 5.666z",
    fill: "#231F20",
    mask: "url(#f)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.556 54.402H14.91C6.689 54.402 0 47.712 0 39.492c0-8.221 6.689-14.91 14.91-14.91h2.302a.811.811 0 010 1.622H14.91c-7.327 0-13.288 5.96-13.288 13.288 0 7.326 5.961 13.287 13.288 13.287h10.646a.811.811 0 110 1.623",
    fill: "#4D3BD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.876 52.605l-3.912-2.26a1.091 1.091 0 00-1.637.946v4.517c0 .84.91 1.365 1.637.945l3.912-2.259a1.09 1.09 0 000-1.89m1.864 4.297a.806.806 0 01-.807-.806v-4.959a.806.806 0 111.612 0v4.96c0 .444-.36.805-.806.805m-1.446-29.513h-6.04a1.914 1.914 0 010-3.83h6.04a1.914 1.914 0 010 3.83",
    fill: "#4D3BD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.564 25.082c-.057 0-.094.019-.094.061 0 .167.594.068.594.478 0 .242-.214.357-.47.357a.926.926 0 01-.545-.18l.126-.256a.777.777 0 00.423.174c.072 0 .117-.025.117-.077 0-.172-.593-.063-.593-.463 0-.22.186-.359.47-.359.173 0 .352.052.475.132l-.125.26a.942.942 0 00-.378-.127m1.548.886l-.265-.415-.128.143v.272h-.337v-1.136h.337v.438l.381-.438h.39l-.412.462.437.674z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#h)",
    d: "M23.811 25.969h.338v-1.137h-.338zm1.397-.724c0-.099-.06-.154-.162-.154h-.166v.312h.166c.102 0 .162-.056.162-.158m.327-.01c0 .271-.173.427-.473.427h-.182v.307h-.345v-1.137h.527c.3 0 .473.146.473.404"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.995 7.22h-33.4a.742.742 0 110-1.484h33.4a.742.742 0 110 1.484M38.15 10.877H19.595a.742.742 0 010-1.485H38.15a.742.742 0 110 1.485m33.716 18.088h-33.4a.742.742 0 110-1.484h33.4a.742.742 0 110 1.484m-14.845 3.657H38.466a.742.742 0 010-1.484H57.02a.742.742 0 110 1.484",
    fill: "#DFDDE6",
    mask: "url(#h)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToAnswer);
export default __webpack_public_path__ + "static/media/how-to-answer.2700fba6.svg";
export { ForwardRef as ReactComponent };